import { Pipe, PipeTransform } from '@angular/core';
import { Tax } from '../../../../../core/models/ticket.model';

@Pipe({
  name: 'taxPercentage',
  standalone: true,
})
export class TaxPercentagePipe implements PipeTransform {
  transform(tax: Tax): string {
    return `${tax.name} ${tax.rate * 100}%`;
  }
}
